import { __assign } from 'tslib';
import React from 'react';
import { canClone } from '../../utils/canClone/canClone.esm.js';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import StepperContext from './StepperContext.esm.js';

var StepperMain = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? "horizontal" : _b, _c = _a.dataTestId, dataTestId = _c === void 0 ? "stepper" : _c, _d = _a.dataMetrics, dataMetrics = _d === void 0 ? "stepper-metrics" : _d, addClassName = _a.addClassName, children = _a.children, _e = _a.responsive, responsive = _e === void 0 ? false : _e;
    var isVertical = direction === "vertical";
    return (React.createElement("div", { "data-metrics": dataMetrics, className: classNames("tw-flex") },
        React.createElement("div", { "data-testid": dataTestId, className: classNames("tw-flex tw-font-lato tw-relative", isVertical && "tw-flex-col", !isVertical && responsive && "tw-grow", addClassName) }, children)));
};
var Stepper = function (props) {
    var direction = props.direction, children = props.children, spacing = props.spacing, vSpacing = props.vSpacing;
    var context = { direction: direction, spacing: spacing, vSpacing: vSpacing };
    var steps = React.Children.map(children, function (step, index) {
        if (!canClone(step))
            return step;
        return React.cloneElement(step, __assign({ index: index, last: index + 1 === (Array.isArray(children) && children.length) }, step.props));
    });
    return (React.createElement(StepperContext.Provider, { value: context },
        React.createElement(StepperMain, __assign({}, props), steps)));
};

export { Stepper };
//# sourceMappingURL=Stepper.esm.js.map
